// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCtpwNjK4jRYhP-V65epBpFrIRBTak48xU",
  authDomain: "pmi-togo.firebaseapp.com",
  projectId: "pmi-togo",
  storageBucket: "pmi-togo.appspot.com",
  messagingSenderId: "12344714852",
  appId: "1:12344714852:web:3cdb859f164b4032886171",
  measurementId: "G-F3GHF8VW80"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const firestoreDatabase = getFirestore(app);
const storage = getStorage(app);

export { auth, firestoreDatabase, storage };